import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Div, Input, DatePicker, Select, TextArea, DropDownList, InputDecimal } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import {
    createUserManualAction,
    clearErrorMsgAction
} from '../../redux/actions/UserManualAction'
import { Constants, MessageText, Storage } from '../../configs'
import { msg } from '../Notifications/MsgBox';
import { async } from "q";
import { getAllOrgUnitsAction } from "../../redux/actions/MasterAction";
import {
    setKeyValueAction as setKeyValueEmployeeModalAction,
    clearModalAction as clearEmployeeModalAction,
} from '../../redux/actions/ModalEmployeeAction'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import unitCodeReviewer from '../../configs/datas/unitcode_reviewer'
import { UserManualService } from "../../services";
class UserManualModal extends Component {

    constructor(props) {
        super(props)
        this.FileControl = React.createRef()
        this.state = {
            ...props,
            userManualModal: {},
            isView: false,
            title: "",
            detail: "",
            usergroup:"Creator",
            file: null,
        }

        this.handleChange = this.handleChange.bind(this)
        this.onClickHandler = this.onClickHandler.bind(this)
        this.clearData = this.clearData.bind(this)

    }

    async handleChange(event) {
        const { name, value, files } = event.target;

        if (name !== "file") {
            await this.setState({ [name]: value })
        }
        else {
            let fileSp = value.split("\\");
            let title = fileSp.length > 0 ? fileSp[fileSp.length - 1] : "";

            await this.setState({
                ...this.state,
                file: files[0],
                title: title
            })
        }


    }

    validateFileUpload() {
        try {
            let { title, file } = this.state
            if (file != "") {
                if (!title || title.trim() === '') {
                    msg.error('กรุณาระบุชื่อเอกสาร')
                    return false
                }
                if (file == null) {
                    msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
                    return false
                }

                return true;
            }
            else {
                msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
                return false
            }

        } catch (error) {

        }

        return false
    }

    async onClickHandler() {
        let { file, title, detail,usergroup } = this.state;
        let { onUploadComplete } = this.props;
        const isValid = this.validateFileUpload()
        const user = Storage.getUser()
       
        let localuser = "admin"
        if (user) {
            localuser = user.userName
        }

        if (isValid) {
            const data = new FormData()
            await
                data.append('title', title)
            data.append('detail', detail)
            data.append('userGroup',usergroup)
            data.append('createBy', localuser)
            data.append('file', file)

            this.props.addUserManual(data).then(() => {
                this.props.getUserManualData().then(() => {
                    this.clearData();
                    onUploadComplete();
                })
            }).catch(error => console.log("error : " + error));

        }

    }

    async clearData(){

        this.FileControl.current.value = ''
        this.setState({
            userManualModal: {},
            isView: false,
            title: "",
            detail: "",
            usergroup:"Creator",
            file: null,
        })
    }

    render() {
        const roleAdmin = Storage.getRoleAdmin()
        const { title, detail, file } = this.state

        return (
            <div className="modal fade sp-modal rrs-modal" id="userManualModal" tabIndex={-1} role="dialog" aria-labelledby="userManualModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="userManualModalLabel">เพิ่ม/แก้ไข UserManual</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <div className="rrs-detail-data sp-table-container">
                                    <div className="row">
                                        <div className="col-12 d-flex align-items-center">
                                            <i className="icon btn-plus" />
                                            <span className="ml-3">Browse file here  <small>(The maximum file size is 50 MB)</small></span>
                                        </div>
                                    </div>
                                    <div className="rrs-file-browse">
                                        <input accept="application/pdf" type="file" id={`file`} name="file" ref={this.FileControl} onChange={(event) => this.handleChange(event)} key={this.state.inputKey} />
                                    </div>
                                    <div className="container" style={{ marginTop: '10px' }}>
                                        <div className="row">
                                            <div className="col-2" style={{ padding: '0' }}>
                                                <label >กลุ่มผู้ใช้ <span className="required">*</span> :</label>
                                            </div>
                                            <div className="col-10" style={{ paddingLeft: '5px', paddingRight: '0' }}>
                                                <Select
                                                    type="text"
                                                    //disabled={roleAdmin ? false : true}
                                                    name="usergroup"
                                                    value={this.state.usergroup}
                                                    className="usergroup"
                                                    id="usergroup"

                                                    tagid="user.group"
                                                    onChange={this.handleChange}>
                                                    <option key='Creator' value='Creator' >Creator</option>
                                                    <option key='Reviewer' value='Reviewer'>Reviewer</option>
                                                    <option key='Committee' value='Committee'>Committee</option>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingTop: 10 }}>
                                            <div className="col-2" style={{ padding: '0' }}>
                                                <label >ชื่อเอกสารแนบ <span className="required">*</span> :</label>
                                            </div>
                                            <div className="col-10" style={{ paddingLeft: '5px', paddingRight: '0' }}>
                                                <Input
                                                    //type="text"
                                                    id={`title`}
                                                    name="title"
                                                    className="form-control"
                                                    value={title}
                                                    onChange={(event) => this.handleChange(event)}
                                                    maxlength="100"
                                                />
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingTop: 10 }}>
                                            <div className="col-2" style={{ padding: '0' }}>
                                                <label >รายละเอียด :</label>
                                            </div>
                                            <div className="col-10" style={{ paddingLeft: '5px', paddingRight: '0' }}>
                                                <textarea
                                                    //type="text"
                                                    id={`detail`}
                                                    name="detail"
                                                    className="form-control"
                                                    value={detail}
                                                    onChange={(event) => this.handleChange(event)}
                                                    maxlength="500"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0 header-button-row mt-3">
                                    <div className="col-12 sp-header-button-panel2">
                                        <button href="#" className="sp-btn-icon btn-del" data-dismiss="modal" onClick={this.clearData}>
                                            <i className="icon btn-order-delete"></i><span className="sp-btn-icon-label">Close</span>
                                        </button>
                                        <button href="#" className="sp-btn-icon" onClick={this.onClickHandler}>
                                            <i className="icon btn-order-savedraft"></i><span className="sp-btn-icon-label">Upload</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

const mapStateToProps = state => {
    const { UserRedux, MasterRedux } = state
    return {
        userManualData: UserRedux.userManualData,
        userManualModal: UserRedux.userManualModal,
        errorMsg: UserRedux.errorMsg,
        org_unit: MasterRedux.org_unit,
        usererrorMsg: UserRedux.usererrorMsg,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addUserManual: (data) => dispatch(createUserManualAction(data)),
        clearErrorMsg: () => dispatch(clearErrorMsgAction()),
        getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        clearEmployeeModal: () => dispatch(clearEmployeeModalAction()),
        setKeyValueEmployeeModal: (table, empCode, empName) => dispatch(setKeyValueEmployeeModalAction(table, empCode, empName)),
        

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserManualModal)